import React from "react";


export const Checkbox = React.forwardRef(({ indeterminate, condition=true, isHeader = false, ...rest }, ref) => {
    const defaultRef = React.useRef()
    const resolvedRef = ref || defaultRef
  
    React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate])


    

    if (condition || isHeader) {        
            return (
                <>
                    <input type="checkbox" ref={resolvedRef} {...rest} />
                </>
            )    
    }
    else {
        return (
            <div ref={resolvedRef} ></div>
        )
    }



}
)